import * as React from 'react';
import { PageRoutes } from '../root/Routes';
import './authentication.css';
import { DONT_HAVE_AN_ACCOUNT_YET_MESSAGE, LUCIDLINK_WEBSITE, SIGN_UP_MESSAGE } from '../../utils/constants';
import { LucidLinkLogo } from '../common/Icons';
import { CardHeader } from '../common/authenticationCardComponents/CardHeader';
import { AuthenticationFooter } from '../common/authenticationCardComponents/AuthenticationFooter';

class CodeExpired extends React.Component <any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
        <div className="auth">
          <div className="auth_wrapper">
            <header>
              <a href={LUCIDLINK_WEBSITE}>
                <LucidLinkLogo width={'130px'} height={'50px'}/>
              </a>
            </header>
            <div className="auth_block">
              <div>
                <CardHeader message={'Expired verification code'}/>
                <div className="center">
                  <p className="red mb-0">Your verification code has expired</p>
                  <p>Click below to return to the sign-up page</p>
                </div>
                <button
                    id="sign_up"
                    className="btn"
                    onClick={this.redirectToSignUp}
                >
                  Return to Sign up
                </button>
              </div>
            </div>
            <AuthenticationFooter message={{ text: DONT_HAVE_AN_ACCOUNT_YET_MESSAGE, label: SIGN_UP_MESSAGE }}/>
          </div>
        </div>
    );
  }

  redirectToSignUp = () => {
    this.props.history.push(PageRoutes.Register);
  }
}

export default CodeExpired;



// WEBPACK FOOTER //
// ./src/webportal/components/authentication/CodeExpired.tsx